import { render, staticRenderFns } from "./myMail.vue?vue&type=template&id=314d16a3&scoped=true"
import script from "./myMail.vue?vue&type=script&lang=js"
export * from "./myMail.vue?vue&type=script&lang=js"
import style0 from "./myMail.vue?vue&type=style&index=0&id=314d16a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314d16a3",
  null
  
)

export default component.exports